export default {
    emailEditor: {
        tabs: {
            add: "Agregar",
            settings: "Configuración",
            blocks: "Bloques",
            modules: "Módulos",
            layout: "Diseño",
        },
        add: {
            sections: "Secciones",
            rows: "Filas",
            showMore: "Ver más",
            showLess: "Ver menos",
        },
        defaults: {
            imageAlt: "Imagen",
            textContent: "Tu texto aquí...",
        },
        topbar: {
            undo: "Deshacer",
            redo: "Rehacer",
            clearSelection: "Limpiar selección",
            preview: "Vista previa",
            backToEditor: "Volver al editor",
            copyHtml: "Copiar HTML",
            templateGallery: "Galeria de templates",
            saveAsTemplate: "Guardar como template",
            close: "Cerrar",
            save: "Guardar",
            settings: "Configuracion",
            emailSettings: "Configuracion del email",
        },
        templateGallery: {
            title: "Galeria de templates",
            subtitle: "Elige un template para empezar a editar.",
            loading: "Cargando...",
            noScreenshot: "Sin screenshot",
            blankModel: "Modelo vacio",
            place: "Del establecimiento",
            global: "Global",
            close: "Cerrar",
            startBlank: "Comenzar en blanco",
        },
        saveAsset: {
            editTitle: "Editar {0}",
            saveAsTitle: "Guardar como {0}",
            editSubtitle: "Actualiza nombre/visibilidad.",
            createSubtitle: "Dale un nombre y elige la visibilidad.",
            name: "Nombre",
            namePlaceholder: "Ej.: Promocion de Verano",
            visibility: "Visibilidad",
            placeVisibility: "Visible solo para este establecimiento",
            globalVisibility: "Visible para todos",
            placeHint: "Visible solo para este establecimiento.",
            delete: "Eliminar",
            cancel: "Cancelar",
            save: "Guardar",
            saving: "Guardando…",
            kindModule: "modulo",
            kindTemplate: "template",
        },
        ai: {
            badge: "Kevi IA",
            hint: "Describe lo que quieres cambiar en el email. Usa Enter para nuevas lineas. Enviar: Ctrl+Enter / Cmd+Enter.",
            placeholder: "Ej.: Cambia el titulo a 'Promocion de Verano', deja el boton verde y mueve el bloque de imagen hacia arriba.",
            ariaLabel: "Editar email con IA",
            apply: "Aplicar con IA",
            applying: "Aplicando…",
            loadingAria: "Generando con IA",
            loadingSubtitle: "Esto puede tardar hasta 1 minuto.",
            loadingSentenceAnalyze: "Analizando tu pedido…",
            loadingSentenceStructure: "Entendiendo la estructura del email…",
            loadingSentenceApply: "Aplicando cambios en el layout…",
            loadingSentenceAdjust: "Ajustando estilos y espaciados…",
            loadingSentenceReview: "Revisando el JSON final…",
            loadingFallback: "Generando cambios…",
        },
        modules: {
            loading: "Cargando modulos...",
            empty: "Ningun modulo disponible.",
        },
        mobile: {
            insertHere: "Insertar aqui",
            moveRowHere: "Mover fila aqui",
            moveSectionHere: "Mover seccion aqui",
            moveColumnHere: "Mover columna aqui",
            moveBlockHere: "Mover bloque aqui",
        },
        titles: {
            block: "Bloque: {type}",
            rowSettings: "Configuración de la fila",
            columnSettings: "Configuración de la columna",
            containerSettings: "Configuración del contenedor",
            sectionTag: "(sección)",
            emailDesign: "Diseño del email",
        },
        common: {
            align: "Alineación",
            top: "Arriba",
            middle: "Centro",
            bottom: "Abajo",
            left: "Izquierda",
            center: "Centro",
            right: "Derecha",
            axisY: "Y",
            axisX: "X",
            unitPercent: "%",
            unitPx: "px",
            width: "Ancho",
            widthAuto: "Automático",
            widthFilled: "Rellenado",
            text: "Texto",
            link: "Enlace",
            linkOptional: "Enlace (opcional)",
            background: "Fondo",
            color: "Color",
            thickness: "Grosor",
            heightPx: "Altura (px)",
            widthPx: "Ancho (px)",
            padding: "Padding",
            margin: "Espacio externo",
            radius: "Redondeo",
            borderRadiusSquare: "Cuadrado",
            borderRadiusSmall: "Pequeño (4px)",
            borderRadiusMedium: "Mediano (8px)",
            borderRadiusLarge: "Grande (16px)",
            borderRadiusXLarge: "Muy grande (32px)",
            borderRadiusCircle: "Círculo",
            paddingHorizontal: "Padding horizontal",
            paddingVertical: "Padding vertical",
            corners: "Esquinas",
            display: "Visualización",
            displayBlock: "En bloque",
            displayInline: "En línea",
            urlPlaceholder: "https://...",
        },
        borderSettings: {
            label: "Borde",
            color: "Color del borde",
            enabled: "Activado",
            disabled: "Desactivado",
            sides: "Lados",
            width: "Grosor",
            style: "Estilo",
        },
        image: {
            url: "URL de la imagen",
            alt: "Texto alternativo",
            chooseFile: "Elegir archivo",
            display: "Visualización",
            displayBlock: "En bloque",
            displayInline: "En línea",
            widthPx: "Ancho (px)",
            borderRadiusPx: "Redondeo",
            objectFit: "Ajuste de la imagen",
            objectFitCover: "Cubrir (cover)",
            objectFitContain: "Contener (contain)",
            objectFitFill: "Rellenar (fill)",
            objectFitNone: "Ninguno (none)",
            objectFitScaleDown: "Reducir (scale-down)",
            aspectRatio: "Proporción (aspect ratio)",
            aspectRatioAuto: "Automático",
            aspectRatioSquare: "Cuadrado (1:1)",
            aspectRatio16x9: "Widescreen (16:9)",
            aspectRatio9x16: "Vertical (9:16)",
            aspectRatio4x3: "Estándar (4:3)",
            aspectRatio3x4: "Retrato (3:4)",
            aspectRatio3x2: "Foto (3:2)",
            aspectRatio2x3: "Retrato (2:3)",
        },
        margins: {
            title: "Espacios",
            topPx: "Superior (px)",
            bottomPx: "Inferior (px)",
            leftPx: "Izquierda (px)",
            rightPx: "Derecha (px)",
            defaults: "Predeterminado: superior 8px, izquierda/derecha 0px.",
        },
        row: {
            columns: "Columnas",
            columnSingular: "columna",
            columnPlural: "columnas",
            align: "Alineación de la fila",
            mobileOrientation: {
                label: "Orientación del contenido en móvil",
                leftOnTop: "Izquierda arriba",
                rightOnTop: "Derecha arriba",
                keepColumns: "Mantener columnas",
            },
            mobileOrientationLeftOnTop: "Izquierda arriba",
            mobileOrientationRightOnTop: "Derecha arriba",
            mobileOrientationKeepColumns: "Mantener columnas",
            paddingTop: "Padding superior",
            paddingBottom: "Padding inferior",
            paddingLeft: "Padding izquierda",
            paddingRight: "Padding derecha",
            columnGap: "Espacio entre columnas",
            background: "Fondo de la fila",
            backgroundHelp: "Defina como blanco para simular bandas separadas.",
            marginHelp: "Espacio fuera del borde de la fila. Úsalo para separar una fila con borde del borde del email.",
        },
        button: {
            canvasHint:
                "Consejo: puedes editar y dar formato directamente en el botón dentro del canvas.",
        },
        column: {
            controls: "Controles de la columna",
            verticalAlignLabel: "Alineación vertical",
            verticalAlignHelp:
                "Controla la alineación vertical del contenido dentro de la columna.",
            backgroundHelp:
                "Aplicado solo dentro de esta columna (no afecta las otras columnas de la fila).",
        },
        emailDesign: {
            background: "Fondo",
            body: "Fondo del contenido",
            emailWidthLabel: "Ancho del email",
            widthPx: "Ancho (px)",
            topSpacingPx: "Espacio superior (px)",
            borderRadiusPx: "Redondeo",
            mobilePaddingPx: "Padding en móvil (px)",
            fontFamily: "Familia de fuente",
            fontHelveticaArial: "Helvetica / Arial",
            fontArial: "Arial",
            fontVerdana: "Verdana",
            fontTahoma: "Tahoma",
            fontTrebuchetMs: "Trebuchet MS",
            fontGeorgia: "Georgia",
            fontTimesNewRoman: "Times New Roman",
            fontCourierNew: "Courier New",
            text: "Texto",
            links: "Enlaces",
            buttonBackground: "Fondo del botón",
            buttonText: "Texto del botón",
        },
        actions: {
            deleteBlock: "Eliminar bloque",
            deleteRow: "Eliminar fila",
            deleteContainer: "Eliminar contenedor",
            duplicateColumn: "Duplicar columna",
        },
        settingsTabs: {
            block: "Bloque",
            column: "Columna",
            row: "Fila",
            section: "Sección",
        },
        settingsEmpty: {
            block: "Seleccione un bloque para editar.",
            column: "Seleccione una columna para editar.",
            row: "Seleccione una fila para editar.",
            section: "Seleccione una sección para editar.",
        },
        backgroundPicker: {
            color: "Color",
            image: "Imagen",
            choose: "Elegir imagen",
            remove: "Remover",
            empty: "Sin imagen",
            size: "Tamaño",
            sizeCover: "Cover",
            sizeContain: "Contain",
            sizeCustomWidth: "Personalizado (ancho)",
            repeat: "Repetición",
            repeatNoRepeat: "No repetir",
            repeatRepeat: "Repetir",
            repeatRepeatX: "Repetir X",
            repeatRepeatY: "Repetir Y",
            position: "Posición",
            positionLeftTop: "Izquierda / Arriba",
            positionCenterTop: "Centro / Arriba",
            positionRightTop: "Derecha / Arriba",
            positionLeftCenter: "Izquierda / Centro",
            positionCenterCenter: "Centro",
            positionRightCenter: "Derecha / Centro",
            positionLeftBottom: "Izquierda / Abajo",
            positionCenterBottom: "Centro / Abajo",
            positionRightBottom: "Derecha / Abajo",
        },
        mobileInsertBar: {
            add: "Agregar",
            chooseOther: "Elegir otro elemento",
            cancelInsertion: "Cancelar inserción",
            insertContent: "Insertar contenido",
            mode: "Modo",
            close: "Cerrar",
            selectMode: "Seleccionar modo",
            cancel: "Cancelar",
            elements: "Elementos",
            row: "Fila {0}",
            loading: "Cargando…",
            noModules: "Ningún módulo",
            module: "Módulo",
            noPreview: "Sin vista previa",
        },
        mobileActionMenu: {
            title: "Acciones",
            editSettings: "Editar configuración",
        },
        preview: {
            device: "Dispositivo de vista previa",
            desktop: "Desktop",
            mobile: "Mobile",
        },
        emptyState: {
            dragBlocksHere: "Arrastra bloques aquí",
            dragModulesOrLayoutsHere: "Arrastra módulos o layouts aquí",
        },
        container: {
            name: "Nombre de la sección",
            add: "Agregar sección",
            controls: "Controles del contenedor",
            personalizationTitle: "Personalización",
            personalizationCreditTooltip:
                "Se consumirá 1 crédito extra por cada email enviado.",
            personalizationCreditAmount: "1 crédito",
            personalizationDescription:
                "Describe cómo Kevi IA debe adaptar esta sección para cada cliente.",
            backgroundHelp:
                "Consejo: use secciones para separar encabezado, cuerpo y pie de página con fondos y paddings diferentes.",
            containerSettings: "Configuración de la sección",
            contentAreaSettings: "Configuración del área de contenido",
            border: "Borde de la sección",
            contentBackground: "Fondo",
            bodyBackground: "Fondo del contenido",
            contentBorder: "Borde",
            contentBorderRadius: "Esquinas",
            paddingHelp: "Espacio alrededor de la tarjeta de contenido dentro de la franja de ancho completo. No separa las filas dentro de la tarjeta.",
        },
        tooltips: {
            dragRow: "Arrastrar fila",
            dragBlock: "Arrastrar bloque",
            drag: "Drag",
            duplicate: "Duplicar",
            delete: "Eliminar",
            edit: "Editar",
            settings: "Configuracion",
            move: "Mover",
            copyStyles: "Copiar estilos",
            saveAsModule: "Guardar como modulo",
            addSectionAbove: "Agregar seccion arriba",
            addSectionBelow: "Agregar seccion abajo",
        },
        prompts: {
            copyHtml: "Copiar HTML",
            linkUrl: "URL del enlace",
            confirmDeleteAsset: "¿Eliminar? Esta acción no se puede deshacer.",
            sendTestEmail: "¿A qué email quieres enviar la prueba?",
        },
        errors: {
            renderHtmlFailed: "Fallo al renderizar el HTML",
        },
        notifications: {
            saveError: "Error al guardar.",
            generatingScreenshot: "Generando screenshot...",
            savingTemplate: "Guardando template...",
            templateSavedGlobal: "¡Template global guardado!",
            templateSaved: "¡Template guardado!",
            selectRowToSaveModule: "Seleccione una fila para guardar como módulo.",
            generatingModuleScreenshot: "Generando screenshot del módulo...",
            savingModule: "Guardando módulo...",
            moduleSavedGlobal: "¡Módulo global guardado!",
            moduleSaved: "¡Módulo guardado!",
            updated: "¡Actualizado!",
            deleted: "¡Eliminado!",
            startBlank: "¡Empezando en blanco!",
            invalidTemplateNoDoc: "Template inválido (sin doc).",
            templateApplied: "¡Template aplicado!",
            invalidModuleNoRow: "Módulo inválido (sin row).",
            moduleInserted: "¡Módulo insertado!",
            saved: "¡Guardado!",
            invalidEmail: "Email inválido.",
            sendingTestEmail: "Enviando prueba a {0}...",
            htmlCopied: "¡HTML copiado!",
            changeTemplateInDevelopment:
                "La funcionalidad de cambiar template está en desarrollo",
            stylePasteBlockHint:
                "Ahora haz clic en otro bloque del mismo tipo para pegar los estilos.",
            stylePasteRowHint: "Ahora haz clic en otra fila para pegar los estilos.",
            stylePasteSectionHint:
                "Ahora haz clic en otra sección para pegar los estilos.",
            stylePasteColumnHint:
                "Ahora haz clic en otra columna para pegar los estilos.",
            duplicateColumnHint:
                "Ahora haz clic en otra columna para duplicar aquí.",
            stylesPasted: "¡Estilos pegados!",
            columnDuplicated: "¡Columna duplicada!",
            styleCopyCancelled: "Copia de estilos cancelada.",
            applyingAi: "Aplicando cambios con IA...",
            emailUpdated: "¡Email actualizado!",
            aiApplyError: "Error al aplicar cambios con IA.",
        },
        palette: {
            blocks: {
                text: "Texto",
                image: "Imagen",
                button: "Botón",
                divider: "Divisor",
                spacer: "Espaciador",
            },
            rows: {
                oneColumn: "Fila: 1 columna",
                twoColumns: "Fila: 2 columnas",
                threeColumns: "Fila: 3 columnas",
            },
        },
        tiptap: {
            font: "Fuente",
            bodyFont: "(Body font)",
            fontHelvetica: "Helvetica",
            fontArial: "Arial",
            fontGeorgia: "Georgia",
            fontTimes: "Times",
            lineHeight: "Altura de línea",
            lineHeightShort: "LH",
            textColor: "Color del texto",
            textBackground: "Fondo del texto",
            textGlyph: "A",
            removeBackground: "Remover fondo",
            bold: "Negrita",
            italic: "Itálica",
            underline: "Subrayado",
            strike: "Tachado",
            snippets: "Snippets",
            size: "Tamaño",
            link: {
                title: "Enlace de texto",
                close: "Cerrar",
                linkTo: "Enlazar a",
                type: {
                    web: "Web",
                    email: "Email",
                    whatsapp: "WhatsApp",
                    phone: "Teléfono",
                    unsubscribe: "Cancelar suscripción",
                },
                web: {
                    url: "URL",
                    placeholder: "Ingrese la URL aquí",
                    invalid:
                        "Ingrese una URL comenzando con http:// o https://",
                },
                email: {
                    address: "Email",
                    placeholder: "email@empresa.com",
                    subject: "Asunto del mensaje",
                    body: "Cuerpo del mensaje",
                },
                whatsapp: {
                    phone: "Teléfono (con código de área)",
                    phonePlaceholder: "(##) #####-####",
                    message: "Mensaje",
                },
                phone: {
                    number: "Teléfono",
                    placeholder: "(##) #####-####",
                },
                unsubscribeHint:
                    "Este enlace será reemplazado automáticamente al enviar el email.",
                save: "Guardar",
                remove: "Remover",
            },
        },
    },
};
